<template>
  <el-dialog
    title="编辑订单"
    :visible.sync="dialogVisible"
    width="900px"
    @close="resetForm"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <el-form
      :model="createForm"
      :rules="rules"
      ref="createForm"
      label-width="140px"
      size="small"
    >
      <!-- 订单基本信息 -->
      <el-form-item label="订单名称：" prop="order_no">
        <el-input v-model="createForm.order_no" placeholder="请输入合同名称"></el-input>
      </el-form-item>
      <el-form-item label="系统订单号：" prop="contract_no">
        <el-input v-model="createForm.contract_no" placeholder="请输入u9等系统订单号"></el-input>
      </el-form-item>
      <el-form-item label="客户名称：" prop="customer_name">
        <el-input v-model="createForm.customer_name" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="销售人员：" prop="ext_01">
        <el-input v-model="createForm.ext_01" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="资源类型：" prop="resource_type">
        <el-input v-model="createForm.resource_type" placeholder="请输入资源类型（例如：H100 16台，管理节点1个）"></el-input>
      </el-form-item>
      <el-form-item label="订单类型：" prop="order_type">
        <el-select v-model="createForm.order_type" placeholder="请选择订单类型" style="width: 100%;">
          <el-option label="开口" :value="0"></el-option>
          <el-option label="闭口" :value="1"></el-option>
          <el-option label="售前测试" :value="2"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="账单日：" prop="billing_day">
        <el-input v-model="createForm.billing_day" placeholder="请输入账单日（如：5）"></el-input>
      </el-form-item>
      <el-form-item label="总价：" prop="total_price">
        <el-input v-model="createForm.total_price" placeholder="请输入总价">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="设备数量：" prop="dev_number">
        <el-input v-model="createForm.dev_number" placeholder="请输入设备数量"></el-input>
      </el-form-item>
      <el-form-item label="货币类型：" prop="currency">
        <el-select v-model="createForm.currency" placeholder="请选择货币类型" style="width: 100%;">
          <el-option label="CNY" value="CNY"></el-option>
          <el-option label="USD" value="USD"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态：" prop="status">
        <el-select v-model="createForm.status" placeholder="请选择订单状态" style="width: 100%;">
          <el-option label="草稿" :value="0"></el-option>
          <el-option label="待审核" :value="1"></el-option>
          <el-option label="生效中" :value="2"></el-option>
          <el-option label="已终止" :value="3"></el-option>
          <el-option label="已到期" :value="4"></el-option>
        </el-select>
      </el-form-item>

      <!-- 价格明细 -->
      <el-form-item label="价格明细：" prop="price_items">
        <div style="margin-bottom: 10px;">
          <el-button size="mini" type="primary" @click="addPriceItem" icon="el-icon-plus">
            添加价格
          </el-button>
        </div>

        <el-table
          :data="priceItems"
          size="mini"
          style="width: 100%"
          border
          :row-key="getRowKey"
        >
          <el-table-column label="名称" width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name" size="mini" placeholder="请输入名称" />
            </template>
          </el-table-column>

          <el-table-column label="规格" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specifications" size="mini" placeholder="如：1核2G" />
            </template>
          </el-table-column>

          <el-table-column label="资源类型" width="120">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.dev_character"
                placeholder="请选择"
                size="mini"
                style="width: 100%;"
                @change="handleResourceTypeChange(scope.row)"
                :disabled="!scope.row.isNew"
              >
                <el-option label="GPU节点" value="GPU节点"></el-option>
                <el-option label="CPU节点" value="CPU节点"></el-option>
                <el-option label="存储" value="存储"></el-option>
                <el-option label="容器云" value="容器云"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="单位" width="60">
            <template slot-scope="scope">
              <span>{{ scope.row.metering_unit || '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="单价（元）" width="90">
            <template slot-scope="scope">
              <el-input
                v-model.number="scope.row.unit_price"
                size="mini"
                placeholder="0.00"
                :disabled="!scope.row.isNew"
              />
            </template>
          </el-table-column>

          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              <el-select v-model="scope.row.status" size="mini" >
                <el-option label="启用" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" size="mini" placeholder="说明" />
            </template>
          </el-table-column>

          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.isNew"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="removePriceItem(scope.$index)"
                circle
              ></el-button>
              <span v-else style="color: #999;">--</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="订单起始时间：" prop="starting_time">
        <el-date-picker
          v-model="createForm.starting_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始时间"
          style="width: 100%;"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="订单结束时间：" prop="end_time">
        <el-date-picker
          v-model="createForm.end_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择结束时间"
          style="width: 100%;"
        ></el-date-picker>
      </el-form-item>

      <!-- 当前附件展示 -->
      <!-- <el-form-item label="当前附件：">
        <div v-if="existingAttachments.length === 0" class="el-upload-list__item is-file">
          暂无附件
        </div>
        <div
          v-for="file in existingAttachments"
          :key="file.id"
          class="el-upload-list__item is-file"
          style="margin: 0px 5px; padding: 5px; border: 0; display: flex; justify-content: space-between; align-items: center;"
        >
          <span class="el-upload-list__item-name">
            <i class="el-icon-document"></i>
            {{ file.file_name }}
          </span>
          <span>
            <el-button
              size="mini"
              type="text"
              @click="downloadAttachment(file.id, file.file_name)"
              style="margin-right: 8px;"
            >
              下载
            </el-button>
            <el-button
              size="mini"
              type="text"
              style="color: #f56c6c;"
              @click="deleteAttachment(file.id)"
            >
              删除
            </el-button>
          </span>
        </div>
      </el-form-item> -->

      <!-- 上传新附件 -->
      <!-- <el-form-item label="上传附件：">
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-remove="handleRemoveAttachment"
          :file-list="fileList"
          :before-upload="beforeUpload"
          multiple
          accept=".pdf,.doc,.docx,.txt,.xlsx,.zip"
          list-type="text"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">支持格式：.pdf, .doc, .docx, .txt, .xlsx, .zip</div>
        </el-upload>
      </el-form-item> -->
    </el-form>

    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditOrderDialog',
  data() {
    const devCharacterUnitMap = {
      'GPU节点': '台·日',
      'CPU节点': '台·月',
      '存储': 'T·月',
      '容器云': '卡·时',
      '其他': '台·月'
    };

    const meteringUnitLabelMap = { '1': '台·日', '2': '卡·时', '3': 'T·月', '4': '台·月' };
   const meteringUnitValueMap = { };
    Object.keys(meteringUnitLabelMap).forEach(key => {
    meteringUnitValueMap[meteringUnitLabelMap[key]] = key;
  });

    return {
      dialogVisible: false,
      rowId: null,
      createForm: {
        order_no: '',
        contract_no: '',
        customer_name: '',
        ext_01: '',
        resource_type: '',
        order_type: 0,
        starting_time: '',
        end_time: '',
        billing_day: '',
        unit_price: '',
        total_price: '',
        currency: '',
        dev_number: '',
        status: 0,
        price_items: [] // 从后端加载的已有价格项
      },
      priceItems: [], // 统一管理：包含已有项（isNew: false）和新增项（isNew: true）
      existingAttachments: [],
      attachments: [], // 新上传的文件列表
      orderResources: [], // 订单资源
      uploadUrl: '/api-30216/api/orders/upload_file',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('token') || '')
      },
      fileList: [],
      devCharacterUnitMap, // ← 已定义
      meteringUnitLabelMap, // ← 加上这个
      meteringUnitValueMap, // ← 必须加上！
      rules: {
        order_no: [{ required: true, message: '请输入合同名称', trigger: 'blur' }],
        customer_name: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        ext_01: [{ required: true, message: '请输入销售人员', trigger: 'blur' }],
        resource_type: [{ required: true, message: '请输入资源类型', trigger: 'blur' }],
        order_type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
        price_items: [
          { validator: this.validatePriceItems, trigger: 'change' }
        ],
        starting_time: [
          {
            required: true,
            validator: (rule, value, callback) => {
              callback(); // 非必填
            },
            trigger: 'change'
          }
        ],
        end_time: [
          {
            validator: (rule, value, callback) => {
              const startTime = this.createForm.starting_time;
              const endTime = value;

              if (!startTime || !endTime) {
                return callback();
              }

              const start = new Date(startTime);
              const end = new Date(endTime);

              if (end <= start) {
                callback(new Error('结束时间必须大于开始时间'));
              } else {
                callback();
              }
            },
            trigger: 'change',
            required: true,
          }
        ],
        billing_day: [
          { required: true, message: '请输入账单日', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              const num = parseInt(value);
              if (!/^\d+$/.test(value)) {
                return callback(new Error('账单日必须为整数'));
              }
              if (num < 1 || num > 28) {
                return callback(new Error('账单日必须为 1~28 之间的整数'));
              }
              callback();
            }, trigger: 'blur' }
        ],
        total_price: [{ required: true, message: '请输入总价', trigger: 'blur' }],
        dev_number: [
          { required: true, message: '请输入设备数量', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              const num = parseInt(value);
              if (!/^\d+$/.test(value)) {
                return callback(new Error('设备数量必须为非负整数'));
              }
              if (num < 0) {
                return callback(new Error('设备数量不能为负数'));
              }
              callback();
            }, trigger: 'blur' }
        ],
        currency: [{ required: true, message: '请选择货币类型', trigger: 'change' }],
        status: [{ required: true, message: '请选择订单状态', trigger: 'change' }],
        total_price: [
          { required: true, message: '请输入总价', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              const num = parseFloat(value);
              if (isNaN(num)) {
                return callback(new Error('总价必须为数字'));
              }
              if (num < 0) {
                return callback(new Error('总价不能为负数'));
              }
              callback();
            }, trigger: 'blur' }
        ],
       
      },

      
    };
  },
  methods: {
    handleResourceTypeChange(row) {
      const unitText = this.devCharacterUnitMap[row.dev_character];
      if (unitText) {
        const unitValue = this.meteringUnitValueMap[unitText] || '4';
        row.metering_unit = unitText;
        if (row.isNew) {
          row._original_metering_unit = unitValue;
        }
      }
    },
    getMeteringUnitLabel(value) {
      const map = {
        '1': '台·日',
        '2': '卡·时',
        '3': 'T·月',
        '4': '台·月'
      };
      return map[value] || '--';
    },

    getRowKey(row) {
      return row.id || row._uid; // 使用 id 或 Vue 内部 _uid 作为唯一 key
    },

    async openDialog(row) {
      this.rowId = row.id;
      this.dialogVisible = true;

      try {
        const res = await this.$axios.get(`/api-30216/api/orders/${this.rowId}`);
        if (res.code === 200) {
          const data = res.data;
          this.createForm = {
            order_no: data.order_no,
            contract_no:data.contract_no,
            customer_name: data.customer_name,
            ext_01: data.ext_01,
            resource_type: data.resource_type,
            order_type: data.order_type,
            starting_time: data.starting_time,
            end_time: data.end_time,
            billing_day: data.billing_day != null ? data.billing_day.toString() : '',
            unit_price: data.unit_price != null ? data.unit_price.toString() : '',
            total_price: data.total_price != null ? data.total_price.toString() : '',
            currency: data.currency,
            dev_number: data.dev_number != null ? data.dev_number.toString() : '',
            status: data.status,
            price_items: Array.isArray(data.price_items) ? data.price_items : []
          };

          // 初始化 priceItems：已有项标记为 isNew: false
          this.priceItems = data.price_items.map(item => {
            const rawUnit = item.metering_unit; // 后端传的 "1", "2"
            const unitText = this.meteringUnitLabelMap[rawUnit] || 
                            this.devCharacterUnitMap[item.dev_character] || 
                            '台·月';

            return {
              ...item,
              isNew: false,
              metering_unit: unitText,
              _original_metering_unit: rawUnit // 保留原始值
            };
          });

          // 初始化 orderResources
          this.orderResources = Array.isArray(data.order_resources) ? data.order_resources : [];
        } else {
          this.$message.error('加载订单信息失败');
          this.dialogVisible = false;
          return;
        }

        const attachRes = await this.$axios.get(`/api-30216/api/orders/attachments/lists/${this.rowId}`);
        if (attachRes.code === 200) {
          this.existingAttachments = attachRes.data || [];
        } else {
          this.$message.warning('加载附件列表失败');
        }

        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      } catch (err) {
        this.$message.error('请求数据失败，请检查网络');
        console.error(err);
        this.dialogVisible = false;
      }
    },

    resetForm() {
      const formRef = this.$refs['createForm'];
      if (formRef) {
        formRef.resetFields();
      }
      this.$refs.upload && this.$refs.upload.clearFiles();
      this.attachments = [];
      this.existingAttachments = [];
      this.rowId = null;
      this.priceItems = []; // 重置价格明细
      this.orderResources = []; // 重置订单资源
    },

    addPriceItem() {
      this.priceItems.push({
        name: '',
        specifications: '',
        dev_character: '',        // 资源类型
        metering_unit: '',        // 单位（自动填充）
        unit_price: 0,
        status: 1,
        remark: '',
        isNew: true
      });
    },

    removePriceItem(index) {
      this.priceItems.splice(index, 1);
    },

    validatePriceItems(rule, value, callback) {
      if (!Array.isArray(this.priceItems) || this.priceItems.length === 0) {
        return callback(new Error('至少添加一条价格明细'));
      }

      for (let i = 0; i < this.priceItems.length; i++) {
        const item = this.priceItems[i];

        if (!item.name || !item.name.trim()) {
          return callback(new Error(`第 ${i + 1} 行：名称为必填项`));
        }

        if (!item.dev_character) {
          return callback(new Error(`第 ${i + 1} 行：资源类型为必选项`));
        }

        const unitPrice = parseFloat(item.unit_price);
        if (isNaN(unitPrice) || unitPrice < 0) {
          return callback(new Error(`第 ${i + 1} 行：单价必须大于等于0`));
        }
      }

      callback();
    },

    beforeUpload(file) {
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/zip'
      ];
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('不支持的文件类型！');
        return false;
      }
      return true;
    },

    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200 && response.filePath) {
        const fileName = file.name;
        const fileSize = file.size;

        this.attachments.push({
          file_name: fileName,
          file_path: response.filePath,
          file_size: fileSize
        });

        this.$message.success(`文件 ${fileName} 上传成功`);
      } else {
        this.$message.error(response.message || '文件上传失败');
      }
    },

    handleRemoveAttachment(file, fileList) {
      const filePath = (file.response && file.response.filePath) || file.url || file.name;
      this.attachments = this.attachments.filter(item => item.file_path !== filePath);
    },

    async downloadAttachment(attachmentId, fileName) {
      try {
        const token = localStorage.getItem('token');
        const url = `/api-30216/api/orders/download_file/${attachmentId}`;

        const res = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!res.ok) {
          throw new Error('下载失败: ' + res.statusText);
        }

        const blob = await res.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName || 'download';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      } catch (err) {
        console.error(err);
        this.$message.error('下载失败，请重试');
      }
    },

    async deleteAttachment(attachmentId) {
      try {
        await this.$axios.delete(`/api-30216/api/orders/attachments/${attachmentId}`);
        this.existingAttachments = this.existingAttachments.filter(item => item.id !== attachmentId);
        this.$message.success('附件删除成功');
      } catch (err) {
        this.$message.error('删除附件失败');
        console.error(err);
      }
    },

    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          this.$message.error('请检查表单填写是否完整');
          return;
        }

        const postData = {
          order_no: this.createForm.order_no,
          contract_no: this.createForm.contract_no,
          customer_name: this.createForm.customer_name,
          ext_01: this.createForm.ext_01,
          resource_type: this.createForm.resource_type,
          order_type: this.createForm.order_type,
          starting_time: this.createForm.starting_time,
          end_time: this.createForm.end_time,
          billing_day: parseInt(this.createForm.billing_day) || null,
          unit_price: parseFloat(this.createForm.unit_price) || 0,
          total_price: parseFloat(this.createForm.total_price) || 0,
          currency: this.createForm.currency,
          dev_number: parseInt(this.createForm.dev_number) || 0,
          status: this.createForm.status,
          price_items: this.priceItems.map(item => {
            const unitText = item.metering_unit;
            const unitValue = this.meteringUnitValueMap[unitText] || '4'; // 安全访问

            return {
              ...item,
              metering_unit: unitValue
            };
          }),
          resources: this.orderResources,
          attachments: [
            ...this.existingAttachments.map(item => ({ id: item.id })),
            ...this.attachments
          ]
        };

        try {
          const res = await this.$axios.put(`/api-30216/api/orders/${this.rowId}`, postData, {
            headers: {
              'Content-Type': 'application/json'
            },
            transformRequest: [data => JSON.stringify(data)]
          });

          if (res.code === 200) {
            this.$message.success('订单更新成功');
            this.dialogVisible = false;
            this.$emit('success');
          } else {
            this.$message.error(res.message || '提交失败，请重试');
          }
        } catch (err) {
          this.$message.error('请求失败，请检查网络或联系管理员');
          console.error('Submit error:', err);
        }
      });
    }
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
.el-upload__tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
.is-file {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-table--mini td,
.el-table--mini th {
  padding: 5px 0;
}
</style>